import axios, { AxiosError } from "axios";
import config from "../Constants/Config";
import type { InfoCardDTO } from "../Models/DTOs/InfoCardDTO";

const WEB_API_URL = process.env.REACT_APP_WEB_API_URL;

export async function GetInfoCard(infoCardId: number, abortController: AbortController) {
    const card = await axios
        .get(`${WEB_API_URL}/v1/${config.infoCards}/${infoCardId}`, {
            signal: abortController.signal,
        })
        .then((result) => result.data as InfoCardDTO)
        .catch((error: AxiosError) => {
            console.log("GetInfoCard");
            throw error;
        });

    return card;
}
